function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { cnm } from "../utils";
var DEFAULT_ELEMENT = "a";
var variants = {
    primary: "text-mid-green ring-mid-green/25",
    neutral: "text-gray-500 ring-gray-500/25",
    unstyled: null
};
var Link = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var as = _param.as, children = _param.children, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _isSubtle = _param.isSubtle, isSubtle = _isSubtle === void 0 ? false : _isSubtle, _isStrong = _param.isStrong, isStrong = _isStrong === void 0 ? false : _isStrong, className = _param.className, props = _objectWithoutProperties(_param, [
        "as",
        "children",
        "variant",
        "isSubtle",
        "isStrong",
        "className"
    ]);
    var Component = as || DEFAULT_ELEMENT;
    return /*#__PURE__*/ _jsx(Component, _objectSpread({}, props, {
        ref: ref,
        className: cnm("\n            rounded-sm ring-mid-green/25 transition hover:underline focus:underline\n            focus-visible:outline-none focus-visible:ring-4\n          ", variant && variants[variant], !isSubtle && "underline", isStrong && "font-medium", className),
        children: children
    }));
});
export { Link };
